import * as React from 'react';
import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField, InputAdornment } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';

import { useAuth } from '../Auth/AuthContext';
import { parseColombianMoneyInput } from '../utils/money';

const API_URL = process.env.REACT_APP_API_URL;

async function actualizarReporteDiario(valor) {
  const hoy = new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Bogota' }); //`${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, "0")}-${String(fecha.getDate()).padStart(2, "0")}`;
  try {
      const response = await axios.get(`${API_URL}/reporte_diario_cajas/`);
      const reportes = await response.data, reporteHoy = reportes.find(r => r.fecha === hoy && r.tipo === 'dinero_base');

      if (reporteHoy) {
          const nuevoValor = parseFloat(reporteHoy.valor) + Number(valor);
          await axios.put(`${API_URL}/reporte_diario_cajas/${reporteHoy.id}/`, { valor: nuevoValor } );
      } else {
          await axios.post(`${API_URL}/reporte_diario_cajas/`, { fecha: hoy, valor: Number(valor), tipo: 'dinero_base' });
      }
  } catch (error) {
      console.error("Error en la actualización del reporte:", error);
  }
}


export default function CajaDialog({ open, onCloseDialog }) {
   const { user } = useAuth();
   const theme = useTheme();

   const [monto, setMonto] = useState('');
   const [error, setError] = useState(false);

   const handleCreateCaja = async () => {
      if (!monto) setError(true);
      else {
         let canonicalAmount;
         try {
            canonicalAmount = parseColombianMoneyInput(monto);
         } catch {
            setError(true);
            return;
         }
         setError(false);

         await actualizarReporteDiario(canonicalAmount);

         const responeEmpleados = await axios.get(`${API_URL}/usuarios/`)
         const currentEmploye = responeEmpleados.data.filter(empleado => empleado.nombre === user.nombre);

         console.log(new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Bogota' }))
         
         axios.post(`${API_URL}/cajas/`, { dinero_base: canonicalAmount, estado: true, empleado: currentEmploye[0].id, nombre: `${user.nombre}-${new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Bogota' })}`, movimientos: []})
          .then(() => {
              onCloseDialog(false);
          });
      }
   };

  return (
    <Dialog open={open}>
      <DialogTitle><strong>¡No puedes acceder!</strong></DialogTitle>
      <DialogContent>
        <Typography>
          No puedes acceder como Empleado a la página si no tienes una <strong>caja creada</strong>, crea una caja para poder ingresar a la página.
        </Typography>
        <Typography style={{ marginTop: '16px', marginBottom: 0, color: '#grey' }}>
         Ponga el monto/dinero base de la caja que va a crear
        </Typography>
        <TextField
          fullWidth
          type="text"
          inputMode="decimal"
          variant="outlined"
          label="Monto Base"
          value={monto}
          InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, maxLength: 10 }} 
          onChange={(e) => setMonto(e.target.value)}
          error={error}
          helperText={error ? 'Ingrese un monto válido en formato colombiano.' : ''}
          margin="normal"
        />
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center' }}>
        <Button variant={theme.palette.mode === 'dark' ? "outlined" : "contained"} color="primary" onClick={handleCreateCaja}>
          Crear Caja
        </Button>
      </DialogActions>
    </Dialog>
  );
}
